export default "__VITE_ASSET__BWV2pSv7__"